import React from 'react';
import ReactPlayer from 'react-player'

class SignageVideoMedia extends React.Component {
    constructor(props) {
        super(props);
        const { mediaData } = props;
        this.state = { mediaData: mediaData };
        this.videoRef = React.createRef();

    }

    componentDidMount() {
        if (!this.videoRef.current) {
            return;
        }
        const { mediaData } = this.props;
        this.videoRef.current.currentTime = mediaData.start_time_offset;
    }

    componentDidUpdate(prevprops) {
        const { mediaData } = this.props;
        if (mediaData.media_id !== this.state.mediaData.media_id) {
            this.setState({ mediaData: mediaData });
        }
    }

    componentWillUnmount() {
        if (!this.videoRef.current) {
            return;
        }
    }

    render() {
        const { mediaData, debug = false, controls = false, brand = "", mall = "", unit = "", debugText = "" } = this.props;
        const videopath = this.videoRef.current ? "url : " + this.videoRef.current.currentSrc : "no path"
        var error = "error : no error"
        if (this.videoRef.current) {
            if (this.videoRef.current.error) {
                error = "error : " + this.videoRef.current.error.message;
            }
        }

        const currentTime = this.videoRef.current ? "currentTime : " + this.videoRef.current.currentTime : "no currentTime"
        var renderDebug = null;
        if (debug) {
            renderDebug = [

                <div key="debug_branch" style={{ backgroundColor: 'white', position: 'absolute', display: 'inline-block', top: '5px', left: '5px' }}>
                    {`brand:${brand}, mall:${mall}, unit:${unit}`}
                </div>,
                <div key="debug_video_path" style={{ backgroundColor: 'white', position: 'absolute', display: 'inline-block', top: '25px', left: '5px' }}>
                    {videopath}
                </div>,
                <div key="debug_video_time" style={{ backgroundColor: 'white', position: 'absolute', display: 'inline-block', top: '45px', left: '5px' }}>
                    {currentTime}
                </div>,
                <div key="debug_video_error" style={{ backgroundColor: 'white', position: 'absolute', display: 'inline-block', top: '65px', left: '5px' }}>
                    {error}
                </div>,
                <div key="debug_text" style={{ backgroundColor: 'white', position: 'absolute', display: 'inline-block', top: '85px', left: '5px' }}>
                    {debugText}
                </div>]
        }
        return (
            <div style={{ width: '100%', height: '100%' }}>
                {renderDebug}
                <video type="video/mp4" controls={controls} key={"media" + this.state.mediaData.media_id} ref={this.videoRef} id={this.state.mediaData.media_id} autoPlay={this.state.mediaData.autoplay} loop={this.state.mediaData.loop} muted={this.state.mediaData.muted} style={{ width: '100%', height: '100%', objectFit: mediaData.scale }}>
                    <source src={this.state.mediaData.path} codecs="avc1.4D401E, mp4a.40.2" />
                </video>
            </div>

            // <ReactPlayer key={"media"+this.state.mediaData.media_id} ref={this.videoRef} id={this.state.mediaData.media_id} url={this.state.mediaData.path} playing={this.state.mediaData.autoplay} loop={this.state.mediaData.loop} muted={this.state.mediaData.muted} style={{width: '100%', height: '100%',objectFit: mediaData.scale }} />
        );
    }
}

export default SignageVideoMedia